import React, { useEffect, useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
import HomepageCarouselSlideContent from './homepageCarouselSlideContent'

const HomepageCarousel = ({ headerImages, openVideoModalCallback, locale }) => {
  const swiperRef = useRef(null)

  useEffect(() => {}, [])

  /* 
    NOTE: Clicking on the Pagination dots does not seem to work in this version of Swiper.
          Next time we update node packages, we should try updating to a newer version of Swiper.
   */

  const buildUrl = (node, url) => {
    if (node.navigation_element !== null && node.navigation_element !== undefined) {
      url = buildUrl(node.navigation_element[0], url)
    }

    if (node.slug) {
      url = url + '/' + node.slug
    }

    return url
  }

  return (
    <Swiper
      tag="section"
      //style={{ height: '100%' }}
      onSwiper={(swiper) => (swiperRef.current = swiper)}
      className="carousel is-hero-carousel p-0"
      modules={[Pagination, Scrollbar, A11y, Autoplay]}
      spaceBetween={20}
      slidesPerView={1}
      slidesPerGroup={1}
      centeredSlides={false}
      watchSlidesProgress={true}
      autoHeight={false}
      noSwiping={true}
      preventClicks={false}
      preventClicksPropagation={false}
      preventInteractionOnTransition={false}
      touchStartPreventDefault={false}
      noSwipingClass="swiper-slide"
      loop={true}
      speed={1000}
      autoplay={false}
      pagination={{
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
        renderBullet: function (index, className) {
          return (
            '<span class="' +
            className +
            '">' +
            '<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" class="scrubicon align-top" data-target=".swiper-slide:not(.swiper-slide-duplicate)[data-swiper-slide-index=\'' +
            index +
            '\'] video">' +
            '<circle class="core" cx="50" cy="50" r="22" stroke-width="2" stroke-dasharray="301.536 301.536" stroke="white" fill="white"></circle>' +
            '<circle class="progress" cx="50" cy="50" r="40" stroke-width="10" stroke-dasharray="301.536 301.536" stroke="white" transform="rotate(-90, 50 50)"></circle>' +
            '</svg>' +
            '</span>'
          )
        },
      }}
      breakpoints={{
        834: {
          slidesPerView: 1,
          slidesPerGroup: 1,
        },
        1194: {
          slidesPerView: 'auto',
          slidesPerGroup: 1,
        },
      }}
    >
      {headerImages.map((headerImage, index) => {
        return (
          <SwiperSlide key={'key' + index} className="override-gatsby swiper-slide">
            <HomepageCarouselSlideContent
              headerImage={headerImage}
              openVideoModalCallback={openVideoModalCallback}
              locale={locale}
            />
          </SwiperSlide>
        )
      })}

      <div className="swiper-pagination"></div>
    </Swiper>
  )
}

export default HomepageCarousel
